import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CatalogFilterConfig } from '@shared-lib/models/domain-catalog.models';

@Component({
  selector: 'app-catalog-filter-panel',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './catalog-filter-panel.component.html',
  styleUrl: './catalog-filter-panel.component.scss',
})
export class CatalogFilterPanelComponent {
  @Input() filters: CatalogFilterConfig[] = [];
  @Input() values: Record<string, string> = {};
  @Input() recordCount = 0;
  @Input() uiConfig: any = null;
  @Output() filterChange = new EventEmitter<{ key: string; value: string }>();
  @Output() resetFilters = new EventEmitter<void>();
}
